module.exports = __webpack_public_path__ + "img/origami-blueberry.8cb0df4b.png";